<template>
  <div class="realtime-rate-item" v-if="this.data">
    <div class="realtime-rate-item__header">
      <div class="realtime-rate-item__flags">
        <img :src="imageURL(this.from)" :alt="this.from" width="25" height="16">
        <img :src="imageURL(this.to)" :alt="this.to" width="25" height="16">
      </div>
      <span class="realtime-rate-item__text" v-text="this.from + '/' + this.to"></span>
    </div>
    <div class="realtime-rate-item__footer">
      <div class="realtime-rate-item__bid">
        <span class="realtime-rate-item__label">Bid</span>
        <span class="realtime-rate-item__num" v-html="splitPrice(this.display, this.data['8. Bid Price'])"></span>
      </div>
      <div class="realtime-rate-item__ask">
        <span class="realtime-rate-item__label">Ask</span>
        <span class="realtime-rate-item__num" v-html="splitPrice(this.display, this.data['9. Ask Price'])"></span>
      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    props: {
      from: {
        type: [String],
        require: true
      },
      to: {
        type: [String],
        require: true
      },
      display: {
        type: [Number],
        require: true
      }
    },
    data() {
      return {
        data: []
      }
    },
    methods: {
      get() {
        axios.get(`//iwsfx.xsrv.jp/apis/data/${this.from}${this.to}.json`)
        .then( (res) => {
          if(res.data['Realtime Currency Exchange Rate']) {
            this.data = res.data['Realtime Currency Exchange Rate']
          }
        })
      },
      imageURL(country) {
        const countryText = country.toLowerCase()
        return `/wp-content/themes/trader-fx/assets/flag/flag-${countryText}.svg`
      },
      splitPrice(count, price) {
        if(price) {
          const basePrice   = String(price).slice( 0, count + 1 - price.length )
          const priceFirst  = basePrice.slice(0, -3)
          const priceMIddle = basePrice.slice(-3, -1)
          const priceLast   = basePrice.slice(-1)
          return `${priceFirst}<span>${priceMIddle}</span>${priceLast}`
        } else {
          return `-----<span>--</span>-`
        }
      }
    },
    mounted() {
      this.get()
    },
  }

</script>
